import { defineComponent } from 'vue'
import { Radio } from 'vant'
import './radio-compat.less'
import CheckLight from './assets/check-light.svg'
import NormalLight from './assets/normal-light.svg'

export default defineComponent({
  name: 'VanRadio',
  inheritAttrs: true,
  setup(_, { attrs, slots }) {
    return () => {
      const { ...rest } = attrs as Record<string, unknown>

      return (
        <Radio
          {...rest}
          icon-size="16px"
          class="fsw-van-radio"
          v-slots={{
            icon: ({ checked }: { checked?: boolean }) => {
              return checked ? <CheckLight /> : <NormalLight />
            },
            ...slots,
          }}
        />
      )
    }
  },
})
